module.exports = require("./es-PE.d.ts");